// import { motion } from "framer-motion";
// import WhyUsBlock from "./WhyUsBlock";
// import diff from '../assest/products/extra/diff.webp'

// const AboutCompanySection = () => {
//   return (
//     <div className="bg-white py-20">

//       <div className="max-w-7xl mx-auto px-4 md:px-6">

//         {/* 🔥 HERO */}
//         <motion.div
//           initial={{ opacity: 0, y: 60 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-20"
//         >
//           <h1 className="text-3xl md:text-5xl font-bold">
//             Corporate IT Solutions <br />
//             <span className="text-blue-600">
//               Refurbished Laptops Experts
//             </span>
//           </h1>

//           <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
//             Reduce IT costs by up to 50% with enterprise-grade refurbished laptops,
//             warranty support, and corporate services.
//           </p>
//         </motion.div>

//         {/* 🔥 IMAGE + ABOUT */}
//         <div className="grid md:grid-cols-2 gap-10 items-center mb-20">

//           <motion.div
//             whileHover={{ scale: 1.02 }}
//             className="rounded-3xl overflow-hidden shadow-lg"
//           >
//             <img
//               src="https://images.unsplash.com/photo-1593642634367-d91a135587b5"
//               className="w-full h-[260px] md:h-[400px] object-cover"
//             />
//           </motion.div>

//           <motion.div
//             initial={{ opacity: 0, x: 60 }}
//             whileInView={{ opacity: 1, x: 0 }}
//           >
//             <h2 className="text-2xl md:text-3xl font-bold mb-4">
//               About Divine Technology
//             </h2>

//             <p className="text-gray-600 leading-relaxed">
//               We provide refurbished laptops, AMC services, and IT asset
//               solutions tailored for startups and enterprises. Our focus is
//               performance, reliability, and long-term cost savings.
//             </p>

//             <div className="mt-6 grid grid-cols-2 gap-4">

//               <div className="bg-gray-100 p-4 rounded-xl text-center">
//                 <h3 className="font-bold text-lg">50+</h3>
//                 <p className="text-xs">Clients</p>
//               </div>

//               <div className="bg-gray-100 p-4 rounded-xl text-center">
//                 <h3 className="font-bold text-lg">ISO</h3>
//                 <p className="text-xs">Certified</p>
//               </div>

//             </div>

//           </motion.div>

//         </div>

//         {/* 🔥 BLOG STYLE SERVICES */}
//         <div className="mb-20">

//           <h2 className="text-2xl md:text-3xl font-semibold mb-8">
//             Our Services
//           </h2>

//           <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">

//             {[
//               {
//                 title: "Refurbished Laptops",
//                 desc: "High-performance laptops at affordable prices with full quality checks and warranty.",
//                 img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8"
//               },
//               {
//                 title: "Laptop Rental",
//                 desc: "Flexible rental solutions for startups and events with zero maintenance hassle.",
//                 img: "https://images.unsplash.com/photo-1519389950473-47ba0277781c"
//               },
//               {
//                 title: "Buyback Programs",
//                 desc: "Sell your old IT assets easily and upgrade to better systems with our buyback plans.",
//                 img: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789"
//               },
//               {
//                 title: "IT Asset Disposal",
//                 desc: "Secure and eco-friendly disposal of IT equipment with certified data destruction.",
//                 img: diff
//               }
//             ].map((item, i) => (

//               <motion.div
//                 key={i}
//                 whileHover={{ y: -6 }}
//                 className="bg-white border rounded-2xl overflow-hidden hover:shadow-lg transition"
//               >

//                 <img
//                   src={item.img}
//                   className="w-full h-60 object-cover"
//                 />

//                 <div className="p-5">

//                   <h3 className="font-semibold text-lg">
//                     {item.title}
//                   </h3>

//                   <p className="text-sm text-gray-600 mt-2 leading-relaxed">
//                     {item.desc}
//                   </p>

//                 </div>

//               </motion.div>

//             ))}

//           </div>

//         </div>

//         <WhyUsBlock/>

//       </div>

//     </div>
//   );
// };

// export default AboutCompanySection;
import { motion } from "framer-motion";
import WhyUsBlock from "./WhyUsBlock";
import diff from '../assest/products/extra/diff.webp';

const services = [
  {
    title: "Refurbished Laptops",
    desc: "High-performance laptops at affordable prices with full quality checks and warranty.",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8"
  },
  {
    title: "Laptop Rental",
    desc: "Flexible rental solutions for startups and events with zero maintenance hassle.",
    img: "https://images.unsplash.com/photo-1519389950473-47ba0277781c"
  },
  {
    title: "Buyback Programs",
    desc: "Sell your old IT assets easily and upgrade to better systems with our buyback plans.",
    img: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789"
  },
  {
    title: "IT Asset Disposal",
    desc: "Secure and eco-friendly disposal of IT equipment with certified data destruction.",
    img: diff
  }
];

const AboutCompanySection = () => {
  return (
    <div className="bg-white py-16 md:py-20">

      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* 🔥 HERO */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 md:mb-20"
        >
          <h1 className="text-2xl md:text-5xl font-bold leading-tight">
            Corporate IT Solutions <br />
            <span className="text-blue-600">
              Refurbished Laptops Experts
            </span>
          </h1>

          <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-sm md:text-base">
            Reduce IT costs by up to 50% with enterprise-grade refurbished laptops,
            warranty support, and corporate services.
          </p>
        </motion.div>

        {/* 🔥 IMAGE + ABOUT */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center mb-16 md:mb-20">

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="rounded-3xl overflow-hidden shadow-md"
          >
            <img
              src="https://images.unsplash.com/photo-1593642634367-d91a135587b5"
              className="w-full h-[240px] md:h-[400px] object-cover"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
          >
            <h2 className="text-xl md:text-3xl font-bold mb-4">
              About Divine Technology
            </h2>

            <p className="text-gray-600 leading-relaxed text-sm md:text-base">
              We provide refurbished laptops, AMC services, and IT asset
              solutions tailored for startups and enterprises. Our focus is
              performance, reliability, and long-term cost savings.
            </p>

            <div className="mt-6 grid grid-cols-2 gap-4">

              <div className="bg-gray-100 p-4 rounded-xl text-center">
                <h3 className="font-bold text-lg">50+</h3>
                <p className="text-xs text-gray-500">Clients</p>
              </div>

              <div className="bg-gray-100 p-4 rounded-xl text-center">
                <h3 className="font-bold text-lg">ISO</h3>
                <p className="text-xs text-gray-500">Certified</p>
              </div>

            </div>

          </motion.div>

        </div>

        {/* 🔥 SERVICES */}
        <div className="mb-16 md:mb-20">

          <h2 className="text-xl md:text-3xl font-semibold mb-6 md:mb-8">
            Our Services
          </h2>

          {/* 📱 MOBILE SLIDER */}
          <div className="flex gap-4 overflow-x-auto pb-2 md:hidden snap-x snap-mandatory">

            {services.map((item, i) => (
              <motion.div
                key={i}
                whileHover={{ y: -5 }}
                className="min-w-[260px] bg-white border rounded-2xl overflow-hidden shadow-sm snap-start"
              >
                <img
                  src={item.img}
                  className="w-full h-40 object-cover"
                />

                <div className="p-4">
                  <h3 className="font-semibold text-base">
                    {item.title}
                  </h3>

                  <p className="text-sm text-gray-600 mt-2">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            ))}

          </div>

          {/* 💻 DESKTOP GRID */}
          <div className="hidden md:grid sm:grid-cols-2 lg:grid-cols-4 gap-6">

            {services.map((item, i) => (
              <motion.div
                key={i}
                whileHover={{ y: -6 }}
                className="bg-white border rounded-2xl overflow-hidden hover:shadow-lg transition"
              >
                <img
                  src={item.img}
                  className="w-full h-48 object-cover"
                />

                <div className="p-5">
                  <h3 className="font-semibold text-lg">
                    {item.title}
                  </h3>

                  <p className="text-sm text-gray-600 mt-2">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            ))}

          </div>

        </div>

        {/* 🔥 WHY US */}
        <WhyUsBlock />

      </div>
    </div>
  );
};

export default AboutCompanySection;